import type { IOverlay } from '../../../../storybook/src/components/jb-overlay/jb-overlay.custom';
import type { IContactOverlay } from '../../../../storybook/src/components/jb-contact-overlay/jb-contact-overlay.custom';
import type { ILinkableClickEventDetail } from '../../../../storybook/src/mixins';
import { JbContactOverlay } from '@bjb/bjb-web-components/dist/components/jb-contact-overlay/jb-contact-overlay.js';

type ContactOverlayDetails = {
  overlay: IOverlay,
  contactOverlay: IContactOverlay,
}

document.body.addEventListener('jb-link:clicked', (event: CustomEvent<ContactOverlayDetails&ILinkableClickEventDetail>) => {
  if (!event.detail.contactOverlay) {
    return;
  }

  if (event.detail.clickEvent) {
    event.detail.clickEvent.preventDefault();
    event.detail.clickEvent.stopPropagation();
  }
  event.stopPropagation();

  const contactOverlayProps = {
    ...event.detail.contactOverlay,
  };

  const overlayProps = {
    ...event.detail.overlay,
    color: 'white',
    hasCloseIcon: true,
    hasLogo: true,
    newAnimation: true,
    returnFocusTo: event.detail.linkTag,
  };
  JbContactOverlay.open(overlayProps, contactOverlayProps).then();
});
